export default __webpack_public_path__ + "static/media/canva.b15f3b7d.svg";